"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reducers = _interopRequireDefault(require("composer-lib/redux/reducers"));

var _usageTrackerMiddleware = _interopRequireDefault(require("composer-lib/lib/usageTrackerMiddleware"));

function configureStore(initialState, _ref) {
  var usageTracker = _ref.usageTracker;
  var createStoreWithMiddleware = (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk.default), (0, _redux.applyMiddleware)((0, _usageTrackerMiddleware.default)(usageTracker)), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
    return f;
  })(_redux.createStore);
  return createStoreWithMiddleware(_reducers.default, initialState);
}

module.exports = exports.default;